/*
 * Flight search loader. The blocking jQuery UI modal this used to open has been
 * replaced by the shared non-blocking IATILoader; the old #loading-flight
 * markup is left in place (hidden) so nothing that references it breaks.
 */
var aerobilet_overlay_new = {
	show : function() { IATILoader.showKey('loading.flight.text', 'js.search.loading.process'); },
	hide : function() { IATILoader.hide(); }
};

function openFlightLoaderBox() {
	aerobilet_overlay_new.show();
}

function closeFlightLoaderBox() {
	aerobilet_overlay_new.hide();
}
